export function isNonNullable<T>(value: T): value is NonNullable<T> {
  return value !== null && value !== undefined;
}

export function assertNonNullable<T>(value: T, msg?: string): NonNullable<T> {
  if (isNonNullable(value)) {
    return value;
  }
  throw new Error(msg ?? "Value is null or undefined");
}

export function assertReutrnNonNullable<T extends (...args: any[]) => any>(
  fn: T,
  msg?: string
): (...args: Parameters<T>) => NonNullable<ReturnType<T>> {
  return (...args) => {
    const result = fn(...args);
    return assertNonNullable(result, msg);
  };
}
